<div class="custom-dialog-container relative confirmation-dialog">
  <mat-dialog-content class="!overflow-hidden">
    <div class="min-h-[120px] my-5 flex flex-col justify-center gap-4">
      @if (data.exists) {
        <div class="flex justify-center items-center min-h-fit min-w-fit">
          <mat-icon class="text-primary bg-slate-100 min-h-fit min-w-fit text-[45px] rounded-full p-4" svgIcon="c:download"></mat-icon>
        </div>
        <div class="font-sans font-bold text-xl flex !justify-center text-center text-primary">
          PDF Already Generated
        </div>
        <div class="text-center text-gray-700 text-sm">
          A PDF for this work order was already generated. You can download it now or generate a new one.
        </div>
      }

      @if (!data.exists && data.async) {
        <div class="flex justify-center items-center min-h-fit min-w-fit">
          <mat-icon class="text-primary bg-slate-100 min-h-fit min-w-fit text-[45px] rounded-full p-4" svgIcon="c:clock-circle"></mat-icon>
        </div>
        <div class="font-sans font-bold text-xl flex !justify-center text-center text-primary">
          Generating PDF…
        </div>
        <div class="text-center text-gray-700 text-sm">
          Estimated time: <strong>{{ data.estimatedTime ?? 'unknown' }}</strong>
        </div>
        <div class="text-center text-gray-500 text-sm">
          You will receive an email with the download link when it's ready.
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="flex !justify-center gap-2 !pb-7 flex-nowrap">
    @if (data.exists) {
      <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button !whitespace-nowrap">Cancel</button>
      <button mat-flat-button color="primary" (click)="onDownloadExisting()" class="text-primary primary-button !whitespace-nowrap">Download Existing</button>
      <button mat-flat-button color="primary" (click)="onGenerateNew()" class="text-primary primary-button !whitespace-nowrap">Generate New</button>
    }

    @if (!data.exists && data.async) {
      <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button">Cancel</button>
    }
  </mat-dialog-actions>
</div>
